import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

// #design-pass: zentrales Panel (Card + Head mit border-bottom). Design-Standard
// für Dashboard-Panels und Detail-Sektionen. icon/action optional; noPad für Tabellen.
export function SectionCard({
  title,
  description,
  icon,
  action,
  children,
  noPad = false,
  className,
  testId,
}: {
  title?: ReactNode;
  description?: ReactNode;
  icon?: ReactNode;
  action?: ReactNode;
  children: ReactNode;
  noPad?: boolean;
  className?: string;
  testId?: string;
}) {
  return (
    <div className={cn("overflow-hidden rounded border border-border bg-surface shadow-sm", className)} data-testid={testId}>
      {(title || action) && (
        <div className="flex items-start justify-between gap-3 border-b border-border px-[18px] py-4">
          <div className="flex items-start gap-3">
            {icon && <span className="mt-0.5 text-text3">{icon}</span>}
            <div>
              {title && <div className="text-[14.5px] font-bold tracking-tight text-text">{title}</div>}
              {description && <div className="mt-0.5 text-[12.5px] text-text3">{description}</div>}
            </div>
          </div>
          {action && <div className="shrink-0">{action}</div>}
        </div>
      )}
      <div className={noPad ? "" : "p-[18px]"}>{children}</div>
    </div>
  );
}
